"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerUrls = void 0;
var ServerUrls = /** @class */ (function () {
    function ServerUrls(queryString) {
        if (queryString && queryString.length > 0) {
            // Prepend a '?' if missing
            queryString = (queryString[0] === '?' ? '' : '?') + queryString;
        }
        else {
            queryString = '';
        }
        this.prefix = '/' + queryString + '#';
    }
    // The full url is prefixed by the query string and puts the path in the hash.
    ServerUrls.prototype.fullUrl = function (path) {
        return this.prefix + path;
    };
    ServerUrls.prototype.serverPath = function (path) {
        return '/server' + path;
    };
    ServerUrls.prototype.sitesUrl = function () {
        return this.fullUrl(this.sitesPath());
    };
    ServerUrls.prototype.sitesPath = function () {
        return this.serverPath('/sites');
    };
    // Users
    ServerUrls.prototype.usersUrl = function () {
        return this.fullUrl(this.usersPath());
    };
    ServerUrls.prototype.usersPath = function () {
        return this.serverPath('/users');
    };
    // While the user identity migration is in process, we move the users space into the users/list subspace.
    ServerUrls.prototype.allUsersListUrl = function () {
        return this.fullUrl(this.allUsersListPath());
    };
    ServerUrls.prototype.allUsersListPath = function () {
        return this.usersPath() + '/list';
    };
    // While the user identity migration is in process, we have an identity subspace for users.
    ServerUrls.prototype.allUserIdentitiesUrl = function () {
        return this.fullUrl(this.allUserIdentitiesPath());
    };
    ServerUrls.prototype.allUserIdentitiesPath = function () {
        return this.usersPath() + '/identities';
    };
    ServerUrls.prototype.schedulesUrl = function () {
        return this.fullUrl(this.schedulesPath());
    };
    ServerUrls.prototype.schedulesPath = function () {
        return this.serverPath('/schedules');
    };
    ServerUrls.prototype.scheduleUrl = function (scheduleId) {
        return this.fullUrl(this.schedulePath(scheduleId));
    };
    ServerUrls.prototype.schedulePath = function (scheduleId) {
        return this.schedulesPath() + '/' + scheduleId;
    };
    ServerUrls.prototype.scheduleExtractRefreshesUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleExtractRefreshesPath(scheduleId));
    };
    ServerUrls.prototype.scheduleExtractRefreshesPath = function (scheduleId) {
        return this.schedulePath(scheduleId) + '/extractRefreshes';
    };
    ServerUrls.prototype.scheduleFlowsUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleFlowsPath(scheduleId));
    };
    ServerUrls.prototype.scheduleFlowsPath = function (scheduleId) {
        return this.schedulePath(scheduleId) + '/flows';
    };
    ServerUrls.prototype.scheduleSubscriptionsUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleSubscriptionsPath(scheduleId));
    };
    ServerUrls.prototype.scheduleSubscriptionsPath = function (scheduleId) {
        return this.schedulePath(scheduleId) + '/subscriptions';
    };
    ServerUrls.prototype.scheduleDataAccelerationUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleDataAccelerationPath(scheduleId));
    };
    ServerUrls.prototype.scheduleDataAccelerationPath = function (scheduleId) {
        return this.schedulePath(scheduleId) + '/dataAcceleration';
    };
    ServerUrls.prototype.scheduleDetailsUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleDetailsPath(scheduleId));
    };
    ServerUrls.prototype.scheduleDetailsPath = function (scheduleId) {
        return this.schedulePath(scheduleId) + '/details';
    };
    ServerUrls.prototype.jobsUrl = function () {
        return this.fullUrl(this.jobsPath());
    };
    ServerUrls.prototype.jobsPath = function () {
        return this.serverPath('/jobs');
    };
    ServerUrls.prototype.tasksUrl = function () {
        return this.fullUrl(this.tasksPath());
    };
    ServerUrls.prototype.tasksPath = function () {
        return this.serverPath('/tasks');
    };
    ServerUrls.prototype.taskPath = function (subspaceName) {
        return this.serverPath('/tasks') + subspaceName;
    };
    ServerUrls.prototype.tasksExtractRefreshesUrl = function () {
        return this.fullUrl(this.tasksExtractRefreshesPath());
    };
    ServerUrls.prototype.tasksExtractRefreshesPath = function () {
        return this.taskPath('/extractRefreshes');
    };
    ServerUrls.prototype.tasksFlowsUrl = function () {
        return this.fullUrl(this.tasksFlowsPath());
    };
    ServerUrls.prototype.tasksFlowsPath = function () {
        return this.taskPath('/flows');
    };
    ServerUrls.prototype.tasksLinkedTasksUrl = function () {
        return this.fullUrl(this.tasksLinkedTasksPath());
    };
    ServerUrls.prototype.tasksLinkedTasksPath = function () {
        return this.taskPath('/linkedTasks');
    };
    ServerUrls.prototype.tasksDataAccelerationUrl = function () {
        return this.fullUrl(this.tasksDataAccelerationPath());
    };
    ServerUrls.prototype.tasksDataAccelerationPath = function () {
        return this.taskPath('/dataAcceleration');
    };
    ServerUrls.prototype.tasksSubscriptionsUrl = function () {
        return this.fullUrl(this.tasksSubscriptionsPath());
    };
    ServerUrls.prototype.tasksSubscriptionsPath = function () {
        return this.taskPath('/subscriptions');
    };
    ServerUrls.prototype.statusUrl = function () {
        return this.fullUrl(this.statusPath());
    };
    ServerUrls.prototype.statusPath = function () {
        return this.serverPath('/status');
    };
    ServerUrls.prototype.settingsUrl = function () {
        return this.fullUrl(this.settingsPath());
    };
    ServerUrls.prototype.settingsPath = function () {
        return this.serverPath('/settings');
    };
    ServerUrls.prototype.settingsLicensesUrl = function () {
        return this.fullUrl(this.settingsLicensesPath());
    };
    ServerUrls.prototype.settingsLicensesPath = function () {
        return this.serverPath('/licenses');
    };
    ServerUrls.prototype.settingsExtensionsUrl = function () {
        return this.fullUrl(this.settingsExtensionsPath());
    };
    ServerUrls.prototype.settingsExtensionsPath = function () {
        return this.serverPath('/extensions');
    };
    ServerUrls.prototype.addSiteUrl = function () {
        return this.fullUrl(this.addSitePath());
    };
    ServerUrls.prototype.addSitePath = function () {
        return this.serverPath('/addSite');
    };
    ServerUrls.prototype.settingsCustomizationUrl = function () {
        return this.fullUrl(this.settingsCustomizationPath());
    };
    ServerUrls.prototype.settingsCustomizationPath = function () {
        return this.serverPath('/customization');
    };
    ServerUrls.prototype.settingsIntegrationsUrl = function () {
        return this.fullUrl(this.settingsIntegrationsPath());
    };
    ServerUrls.prototype.settingsIntegrationsPath = function () {
        return this.serverPath('/integrations');
    };
    ServerUrls.prototype.settingsResourceLimitsUrl = function () {
        return this.fullUrl(this.settingsResourceLimitsPath());
    };
    ServerUrls.prototype.settingsResourceLimitsPath = function () {
        return this.serverPath('/resourceLimits');
    };
    ServerUrls.prototype.settingsConnectedApplicationsUrl = function () {
        return this.fullUrl(this.settingsConnectedApplicationsPath());
    };
    ServerUrls.prototype.settingsConnectedApplicationsPath = function () {
        return this.serverPath('/connectedApplications');
    };
    ServerUrls.prototype.settingsMobileUrl = function () {
        return this.fullUrl(this.settingsMobilePath());
    };
    ServerUrls.prototype.settingsMobilePath = function () {
        return this.serverPath('/mobile');
    };
    ServerUrls.prototype.userUrl = function (domainName, username) {
        return this.fullUrl(this.userPath(domainName, username));
    };
    ServerUrls.prototype.userPath = function (domainName, username) {
        return this.serverPath('/user/' + encodeURIComponent(domainName) + '/' + encodeURIComponent(username));
    };
    ServerUrls.prototype.baseUserPath = function () {
        return this.serverPath(ServerUrls.baseUserPart());
    };
    ServerUrls.baseUserPart = function () {
        return "/user";
    };
    ServerUrls.prototype.userSettingsUrl = function (domainName, username) {
        return this.fullUrl(this.userSettingsPath(domainName, username));
    };
    ServerUrls.prototype.userSettingsPath = function (domainName, username) {
        return this.serverPath('/user/' + encodeURIComponent(domainName) + '/' + encodeURIComponent(username) + '/settings');
    };
    // Server Status Vizzes
    ServerUrls.prototype.serverStatusVizUrl = function (sheetUrlId) {
        return this.fullUrl(this.serverStatusVizPath(sheetUrlId));
    };
    ServerUrls.prototype.serverStatusVizPath = function (sheetUrlId) {
        return this.serverPath(ServerUrls.serverStatusVizPart(sheetUrlId));
    };
    ServerUrls.serverStatusVizPart = function (sheetUrlId) {
        return "/analysis/".concat(sheetUrlId);
    };
    return ServerUrls;
}());
exports.ServerUrls = ServerUrls;
//# sourceMappingURL=ServerUrls.js.map